import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import ResultComparisonChart from "../Charts/ResultComparison";
import LongTradesTable from "./LongTradesTable";
import ShortTradesTable from "./ShortTradesTable";
import InstrumentTradeTable from "./InstrumentTradeTable";

const LongShortComparison = ({ data }) => {
  return (
    <div className="ResultByClose">
      {/* <Grid
        className="longshort-inner"
        item
        xs={12}
        sx={{ paddingLeft: { xs: 0 } }}
      >
        <Card className="card-csc">
          <Title six>Results by Instruments</Title>
          <ResultComparisonChart data={data && data.result_by_instruments} />
        </Card>
      </Grid> */}

      <Title six>Results by Days</Title>
      <Card className="card-csc" sx={{ marginLeft: "15px" }}>
        <InstrumentTradeTable data={data} />
      </Card>
      {/* <Grid className="longshort-inner" item xs={12} md={6}>
        <Card className="card-csc">
          <InstrumentsTable data={data && data.result_by_instruments} />
        </Card>
      </Grid>
      <Grid className="longshort-inner" item xs={12} md={3}>
        <Card className="card-csc">
          <LongTradesTable data={data && data.result_by_instruments} />
        </Card>
      </Grid>
      <Grid className="longshort-inner" item xs={12} md={3}>
        <Card className="card-csc">
          <ShortTradesTable data={data && data.result_by_instruments} />
        </Card>
      </Grid> */}
    </div>
  );
};

export default LongShortComparison;
